import { styled } from '@mui/system';
import { mediaQueries, PHONE } from 'styles/mediaQueries';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const Footer = styled('footer', {
  shouldForwardProp: muiPropForwarding('hideBrandFooterOnMobile')
})(({ hideBrandFooterOnMobile }) => ({
  position: 'relative',
  textAlign: 'center',
  paddingBottom: 0,
  marginTop: '20px',
  // TODO: Refactor how we do media queries for mobile
  [`@media ${mediaQueries[PHONE]}`]: {
    display: hideBrandFooterOnMobile && 'none'
  }
}));

export default Footer;
